import { render, staticRenderFns } from "./ImportDetailSettingsTab.vue?vue&type=template&id=643406fd&scoped=true&"
import script from "./ImportDetailSettingsTab.vue?vue&type=script&lang=js&"
export * from "./ImportDetailSettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./ImportDetailSettingsTab.vue?vue&type=style&index=0&id=643406fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643406fd",
  null
  
)

export default component.exports